import { render } from "./CnRules.vue?vue&type=template&id=c2bf04cc&scoped=true"
import script from "./CnRules.vue?vue&type=script&scoped=true&lang=js"
export * from "./CnRules.vue?vue&type=script&scoped=true&lang=js"

import "./CnRules.vue?vue&type=style&index=0&id=c2bf04cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2bf04cc"

export default script